import {Component, inject, OnDestroy, OnInit} from '@angular/core';
import {WorkstationConfiguration} from "../../../../../services/back/workstation-configuration.service";
import {Subscription, tap} from "rxjs";
import {
	WorkstationDetailData,
	WorkstationDetailService
} from "../../../../../services/front/workstation-detail.service";
import {CommonModule} from "@angular/common";
import {ApplicationMiniWidgetModule} from "../../../../global/application-mini-widget/application-mini-widget.module";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {TendencyWidgetContent} from "../../../../global/application-mini-widget/application-mini-widget.component";
import {HealthStatus} from "../../../../../services/model/new-application.model";
import {DashboardPageLoaderComponent} from "../../../../global/title-content-loader/dashboard-page-loader.component";
import {WorkstationInformationComponent} from "./workstation-information/workstation-information.component";
import {WorkstationUsersComponent} from "./workstation-users/workstation-users.component";
import {WorkstationResourcesComponent} from "./workstation-resources/workstation-resources.component";
import {DesignSystemModule} from "../../../../design-system/design-system.module";
import {DataCollectionStatus} from "../../../../../services/model/server.model";

@Component({
  selector: 'app-workstation-overview-tab',
	imports: [
		CommonModule,
		ApplicationMiniWidgetModule,
		TranslateModule,
		DashboardPageLoaderComponent,
		WorkstationInformationComponent,
		WorkstationUsersComponent,
		WorkstationResourcesComponent,
		DesignSystemModule
	],
  templateUrl: './workstation-overview-tab.component.html',
  styleUrl: './workstation-overview-tab.component.scss'
})
export class WorkstationOverviewTabComponent implements OnInit, OnDestroy {
	tenantId: string;
	isEditor: boolean;
	isTenantInactivePlan: boolean;

	workstation: WorkstationConfiguration;
	healthWidget: TendencyWidgetContent|undefined;

	_initializing: boolean;
	_loading: boolean;
	initialized: boolean = false;

	subscription: Subscription = new Subscription();

	private workstationDetailService = inject(WorkstationDetailService);
	private translate = inject(TranslateService);

	ngOnInit() {
		this.subscription.add(this.workstationDetailService.getInitializingChanges()
			.subscribe(initializing => this._initializing = initializing));
		this.subscription.add(this.workstationDetailService.getWorkstationDetailDataChanges()
			.pipe(tap(data => this.setWorkstationDetailData(data)))
			.subscribe(() => this.initialized = true));
	}

	private setWorkstationDetailData(data: WorkstationDetailData): void {
		this.tenantId = data.tenantId;
		this.isEditor = data.isEditor;
		this.workstation = data.workstation;
		this.isTenantInactivePlan = data.isInactivePlan;
		this.healthWidget = {
			value: data.workstation.health === HealthStatus.GOOD ? 99 : data.workstation.health === HealthStatus.NEEDS_IMPROVEMENT ? 95 : 0,
		};
	}

	getUptime(): string {
		const uptime = this.workstation.uptime;
		if (uptime < 60) {
			return `${uptime} ${this.translate.instant('global.seconds')}`;
		} else if (uptime < 3600) {
			return `${Math.floor(uptime / 60)} ${this.translate.instant('global.minutes')}`;
		} else if (uptime < 86400) {
			return `${Math.floor(uptime / 3600)} ${this.translate.instant('global.hours')}`;
		} else {
			return `${Math.floor(uptime / 86400)} ${this.translate.instant('global.days')}`;
		}
	}

	getUptimeDate(): string {
		const uptime = this.workstation.uptime;
		const lastCheckDate: number = new Date(this.workstation.lastCollectDate).getTime();
		const date = new Date(lastCheckDate - uptime * 1000);
		return date.toLocaleDateString();
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	protected readonly DataCollectionStatus = DataCollectionStatus;
}
